import { Routes } from '@angular/router';
import { CursoDetalleComponent } from '../components/curso-detalle/curso-detalle.component';
import { CursosOfertadosComponent } from '../components/cursos-ofertados/cursos-ofertados.component';
import { FormLoginComponent } from '../components/form-login/form-login.component';
import { FormPostulacionComponent } from '../components/form-postulacion/form-postulacion.component';

import { HomeComponent } from '../components/home/home.component';
import { CertificadosComponent } from '../components/micuenta/certificados/certificados.component';
import { CursosComponent } from '../components/micuenta/cursos/cursos.component';
import { DashboardComponent } from '../components/micuenta/dashboard/dashboard.component';
import { DatosPersonalesComponent } from '../components/micuenta/datos-personales/datos-personales.component';
import { MicuentaComponent } from '../components/micuenta/micuenta.component';
import { PostulacionesComponent } from '../components/micuenta/postulaciones/postulaciones.component';
import { RecuperarCodigoComponent } from '../components/recuperar-codigo/recuperar-codigo.component';
import { SessionService } from '../services/session.service';

const appRoutes: Routes = [
    { path: '', component: HomeComponent },
    { path: 'cursos-ofertados', component: CursosOfertadosComponent },
    { path: 'curso-detalle', component: CursoDetalleComponent },
    { path: 'postulacion', component: FormPostulacionComponent },
    { path: 'login', component: FormLoginComponent },
    { path: 'recuperar-codigo', component: RecuperarCodigoComponent },
    { path: 'micuenta', canActivate: [SessionService], component: MicuentaComponent, children: 
        [
            { path: 'dashboard', canActivate: [SessionService], component: DashboardComponent },
            { path: 'postulaciones', canActivate: [SessionService], component: PostulacionesComponent },
            { path: 'cursos', canActivate: [SessionService], component: CursosComponent },
            { path: 'certificados', canActivate: [SessionService], component: CertificadosComponent },
            { path: 'datos-personales', canActivate: [SessionService], component: DatosPersonalesComponent }
        ] 
    }

];

export default appRoutes;
